<template>
  <div id="clientes-toolbar-clientes">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Clientes
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
